import React, { useEffect } from 'react'
import { observer, inject } from 'mobx-react'
import { Icon, Avatar, Age, T, FreeChatWindowTimer, FreeChatWindowRing } from 'components/misc'
import { MODES } from 'core/constants'
import ConversationSearch from './ConversationSearch'
import AvatarStatusBubble from 'components/misc/AvatarStatusBuble'
import UnreadMessagesBadge from 'components/misc/UnreadMessagesBadge'
import DigitalSweety from './DigitalSweety'
import classNames from 'classnames';
import VIPBadge from './VIPBadge'
import {onAnchorClick} from 'core/hooks/useNuxtProfileRedirect';

const ChatHeader = ({ isOpen, toggleOpen, store, options, actions }) => {
  const { mode, features, translations: { basic }, s3Path, isExternalUpgradeSite } = options
  const user = store.user
  const profile = store.conversation.otherUserProfile
  const conversationUid = store.conversationUid
  const profileId = profile?.externalUserId || null;
  const location = store.conversation.location
  const showDistanceInsteadLocation = store.conversation.otherUserProfile?.showDistanceInsteadOfLocation || false
  const creditsRevealMessage = (user.premium && features.isCreditSite && showDistanceInsteadLocation) ? features.creditsForLocationReveal : null
  let nuxtHref, nuxtPathname = ''
  if (CONFIG.isNuxt) {
    nuxtHref = profile
      ? new URL(CONFIG.urls.profile(profile), window.location.origin)
      : null
    nuxtPathname = nuxtHref?.pathname
  }
  const onDelete = () => {
    store.popupType = 'delete'
  }

  useEffect(() => {
    options.hooks.onReady(store.widgetState, store.user)
  }, [])

  const handleGoBack = () => {
    actions.chat.setUserConversation(null)
  }

  const handleResponseFromDating = message => {
    store.conversation.setLocation(message)
  }

  const handleRevealLocation = e => {
    e.preventDefault()
    profileId && options.hooks?.onRevealLocation?.(profileId, handleResponseFromDating)
  }

  const generateDistance = () => {
    const distanceMessage = store.conversation.otherUserProfile?.distance > 1 ? basic.withinXMiles.replace('{distance}', store.conversation.otherUserProfile?.distance) : basic.within1Mile
    return <div className="distance-container">{distanceMessage}<span onClick={handleRevealLocation}>{basic.reveal}</span></div>
  }

  return (
    <div className="chat-header">
      <FreeChatWindowTimer/>
      {features.virtualHottie && mode === MODES.WIDGET &&
        <span className={classNames({ hidden: !isOpen}, 'ccp-virtual-hottie')}>
        <T>virtualHottie.virtualHottie</T>
        <span className="ccp-virtual-hottie-description">
          <T>virtualHottie.automatedProfile</T> <a href={CONFIG.urls.terms}><T>virtualHottie.termsAndConditions</T></a>
        </span>
      </span>}
      {mode !== MODES.CHAT_LIST && profile && isOpen && (
        <div className={`profile ${mode}`}>
          {mode === (MODES.SIDEBAR || MODES.CHAT_LIST) && <Avatar user={profile} isActive/>}
          {features.virtualHottie && mode === MODES.SIDEBAR &&
            <span className={classNames({ hidden: !isOpen}, 'ccp-virtual-hottie')}>
            <T>virtualHottie.virtualHottie</T>
            <span className="ccp-virtual-hottie-description">
              <T>virtualHottie.automatedProfile</T> <a href={CONFIG.urls.terms}><T>virtualHottie.termsAndConditions</T></a>
            </span>
          </span>}
          <div className="username-container">
            <a href={CONFIG.isNuxt ? nuxtPathname : options.urls.profile(profile)} onClick={CONFIG.isNuxt ? e => onAnchorClick(e, nuxtHref, nuxtPathname, profile) : undefined} className="username">{profile.username}</a>
            {features.virtualHottie && mode === MODES.VERTICAL &&
              <span className="ccp-virtual-hottie">
                <T>virtualHottie.virtualHottie</T>
                <span className="ccp-virtual-hottie-description">
                  <T>virtualHottie.automatedProfile</T> <a href={CONFIG.urls.terms}><T>virtualHottie.termsAndConditions</T></a>
                </span>
              </span>
            }
          </div>
          <span className="age"><Icon iconName="user"/> <Age user={profile} yearsOld={mode === MODES.VERTICAL}/></span>
           <span className="location" style={{ cursor: 'pointer'}}>
              <Icon iconName="location"/>
              {creditsRevealMessage && <div className="credit-cost-tooltip-text">{creditsRevealMessage}</div>}
              { showDistanceInsteadLocation ? generateDistance() : location }
            </span>
          {/* AVN-1396: in the row, kept clear of the delete button, which is pinned to the row's corner. */}
          <FreeChatWindowRing className={features.canDelete ? 'ccp-fcw-ring--beside-delete' : ''}/>
          {!!features.canDelete && <span className="delete" onClick={onDelete}>✖</span>}
        </div>
      )}
      { mode === MODES.VERTICAL && <Icon iconName="arrowDown" className={`m${isOpen ? 'in': 'ax'}imize`} onClick={toggleOpen}/> }
      {mode === MODES.CHAT_LIST && (
        <div className="chat-header__chats">
          {!conversationUid &&
            <>
              <Icon iconName="arrowBack" className="chat-list-back-icon" onClick={toggleOpen}/>
              <T>Chats</T>
              <ConversationSearch/>
            </>}
          {conversationUid && (
            <div className="profile">
              <UnreadMessagesBadge>
                <Icon iconName="arrowBack" className="chat-list-back-icon" onClick={handleGoBack}/>
              </UnreadMessagesBadge>
              <AvatarStatusBubble isOnline={profile.isOnline}>
                <Avatar user={profile} isActive/>
              </AvatarStatusBubble>
            <div className="username-container">
              <a href={CONFIG.isNuxt ? nuxtPathname : options.urls.profile(profile)} onClick={CONFIG.isNuxt ? e => onAnchorClick(e, nuxtHref, nuxtPathname, profile) : undefined} className="username">{profile.username}</a>
              <div className="age age-loction">
                <Age user={profile} yearsOld={mode === MODES.CHAT_LIST}/>{' - '}
                <span className="location">
                  {creditsRevealMessage && <div className="credit-cost-tooltip-text">{creditsRevealMessage}</div>}
                  { showDistanceInsteadLocation ? generateDistance() : location }
                </span>
              </div>
            </div>
          </div>
          )}
            <span className="ccp-virtual-hottie">
              {/* AVN-1396: open conversation only, never over the list. First in this row, so it sits left of the
                  virtual hottie / VIP badge, or in the corner when there is none. */}
              {conversationUid && <FreeChatWindowRing/>}
              {profile.isFeatured && conversationUid && features.featuredFunctionality &&
                <VIPBadge
                  showDescription={true}
                  isVirtualHottie={features.virtualHottie}
                />}
              {features.virtualHottie && conversationUid && <>
                <DigitalSweety
                  svgUrl={`${s3Path}images/virtual_hottie_${isExternalUpgradeSite ? 'external' : 'internal'}.svg`}
                  fallbackText={<T>virtualHottie.virtualHottie</T>}
                />
                  <span className="ccp-virtual-hottie-description">
                    <T>virtualHottie.automatedProfile</T> <a href={CONFIG.urls.terms} className="term-n-conditions"><T>virtualHottie.termsAndConditions</T></a>
                  </span>
                </>}
            </span>
        </div>
      )}
    </div>
  )
}

export default inject('store', 'actions')(observer(ChatHeader))
